export enum EReminderProcessType {
    JOB = "Jobs",
    QUOTE = "Quotes",
    EVENT = "JobEvents",
    OTHER = "Other",
}

export enum EReminderTargetEntity {
    CLIENT = "client",
    WORKFORCE = "workforce",
    COMPANY = "company",
}